import { Box, IconButton, TextField } from '@mui/material';
import React from 'react';
import { bonoBotState, setChatInput } from 'store/bonoBot/bonoBot.slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useSocketInstanceContext } from 'context/socketInstanceContext';
import DynamicGoogleIcon from 'components/dynamic-icon/dynamicGoogleIcon';
import ChatHints from './ChatHints';

const ChatInput = () => {
   const { sendMessageToServerAndChat, isWaitingForResponse } = useSocketInstanceContext();

   const dispatch = useAppDispatch();
   const { chatInput, storedThreadId, messages } = useAppSelector(bonoBotState);

   const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setChatInput(e.target.value));
   };

   const handleSendMessage = () => {
      if (!isWaitingForResponse) {
         const message = chatInput.trim();
         if (message !== '') {
            sendMessageToServerAndChat(message, storedThreadId);
         }
      }
   };

   return (
      <Box
         sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            rowGap: '10px',
            pb: 1.875,
            px: { xs: 2.5, sm: 0 },
            minHeight: '80px',
         }}
      >
         {messages.length === 0 && <ChatHints />}

         <Box
            sx={{
               width: '100%',
               backgroundColor: '#FFFFFF',
               borderRadius: '25px',
               display: 'flex',
               flexDirection: 'row',
               columnGap: '10px',
               flexGrow: 1,
               alignItems: 'center',
               py: 0.5,
               pl: 2,
               pr: 0.5,
               justifyContent: 'space-between',
            }}
         >
            <TextField
               fullWidth
               multiline
               variant='standard'
               placeholder='I want to donate to...'
               InputProps={{
                  disableUnderline: true,
                  sx: { fontSize: '16px', lineHeight: '19px' },
               }}
               onKeyDown={(event: React.KeyboardEvent) => {
                  if (event.key === 'Enter' && !event.shiftKey) {
                     event.preventDefault();
                     handleSendMessage();
                  }
               }}
               value={chatInput}
               onChange={handleOnChange}
            />
            <IconButton
               onClick={handleSendMessage}
               sx={{
                  p: 0,
                  minWidth: 42,
                  minHeight: 42,
                  height: 42,
                  width: 42,
                  display: 'flex',
                  borderRadius: '100%',
                  backgroundColor: '#F55D66',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '&:hover': {
                     backgroundColor: '#FF737B', // Lighter shade of #F55D66
                  },
               }}
            >
               <DynamicGoogleIcon iconColor='#FFFFFF' iconName='arrow_upward' />
               {/* <SendMessageIcon /> */}
            </IconButton>
         </Box>
      </Box>
   );
};

export default ChatInput;
